import { render, staticRenderFns } from "./Video-Swiper.vue?vue&type=template&id=c2184c36&scoped=true"
import script from "./Video-Swiper.vue?vue&type=script&lang=js"
export * from "./Video-Swiper.vue?vue&type=script&lang=js"
import style0 from "./Video-Swiper.vue?vue&type=style&index=0&id=c2184c36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2184c36",
  null
  
)

export default component.exports